import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/Auth";
import { getDefaultAuthenticatedRoute } from "../utils/permissions";

/**
 * Gate a route behind a role/company access check.
 * `canAccess` receives the auth context (or call a helper that accepts it).
 */
export default function RequirePermission({ canAccess, children }) {
  const auth = useAuth();

  if (typeof canAccess === "function" ? !canAccess(auth) : !canAccess) {
    return <Navigate to={getDefaultAuthenticatedRoute(auth)} replace />;
  }

  return children;
}
